var map = {
	"./addAuthorization/en.json": "1be0",
	"./addAuthorization/es.json": "d117",
	"./agreementDocuments/en.json": "fe24",
	"./agreementDocuments/es.json": "c846",
	"./authorizationDetail/en.json": "e690",
	"./authorizationDetail/es.json": "7644",
	"./authorizationDetail/es_MX.json": "49be",
	"./authorizationList/en.json": "70ca",
	"./authorizationList/es.json": "dfe2",
	"./changePassword/en.json": "434d",
	"./changePassword/es.json": "4d3c",
	"./errors/en.json": "4a3d",
	"./errors/es.json": "9cc2",
	"./forgotPassword/en.json": "76af",
	"./forgotPassword/es.json": "90d6",
	"./general/en.json": "5f2e",
	"./general/es.json": "a14c",
	"./login/en.json": "5f95",
	"./login/es.json": "6939",
	"./remanent/en.json": "c4ae",
	"./remanent/es.json": "dab5",
	"./updatePassword/en.json": "0021",
	"./updatePassword/es.json": "cfb6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fdd0";